<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { InstantRangeInput, ListDetailLayout, TextInput } from '@hantera/design-system'
import { AuditDataProvider, type AuditFilters } from './audit-data-provider'
import AuditDetailComponent from './AuditDetailComponent.vue'
import useBackend from '@/composition/useBackend'
import { useContext } from '@hantera/portal-app'

const { audit } = useBackend()
const context = useContext()

if (context.currentView.value?.name) {
  context.currentView.value.name.value = 'Audit Logs'
}

// Filters
const filters = ref<AuditFilters>({
  pathPrefix: '',
  timespan: {
    from: new Date(Date.now() - (1000 * 60 * 60 * 24 * 14)),
    to: new Date(),
  },
  field: ''
})

// Data provider
const auditProvider = new AuditDataProvider(filters, audit)

// Load initial data
onMounted(() => {
  auditProvider.refresh()
})

function applyFilters() {
  auditProvider.refresh()
}

function clearFilters() {
  filters.value = {
    pathPrefix: '',
    timespan: {
      from: new Date(Date.now() - (1000 * 60 * 60 * 24 * 14)),
      to: new Date(),
    },
    field: ''
  }
  auditProvider.refresh()
}
</script>

<template>
  <div class="audit-view">
    <ListDetailLayout
      :provider="auditProvider"
      :detail-component="AuditDetailComponent"
    >
      <template #list-toolbar>
        <div class="audit-toolbar">
          <InstantRangeInput
            v-model="filters.timespan"
          />
          <TextInput
            v-model="filters.pathPrefix"
            placeholder="Resource path prefix..."
            @keyup.enter="applyFilters"
          />
          <TextInput
            v-model="filters.field"
            placeholder="Field name..."
            @keyup.enter="applyFilters"
          />
          <div class="filter-actions">
            <button @click="applyFilters" class="btn-primary">
              Apply
            </button>
            <button @click="clearFilters" class="btn-silent">
              Clear
            </button>
          </div>
        </div>
      </template>
    </ListDetailLayout>
  </div>
</template>

<style scoped>
.audit-view {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.audit-toolbar {
  display: grid;
  grid-template-columns: max-content auto auto auto;
  gap: 5px;
  width: 100%;
}

.filter-actions {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
}
</style>
